import { BoostModal } from '../../../../components/Toolkit/BoostModal/BoostModal';
import type { BoostModalProps } from '../../../../components/Toolkit/BoostModal/types';

interface IRevealBoostModal extends BoostModalProps {
  suggestedProductModalCallback?: (version: string) => void;
}

function RevealBoostModal({
  boostInfoList,
  adId,
  handleSelect,
  ...rest
}: IRevealBoostModal) {
  return (
    <>
      {boostInfoList && adId && (
        <BoostModal
          boostInfoList={boostInfoList}
          handleSelect={handleSelect}
          adId={adId}
          {...rest}
        />
      )}
    </>
  );
}

export { RevealBoostModal };
